export const LENS_TYPES = {
    '7': 'Bifocal/Progressive',
    '6': 'Single Vision',
};
